import React from 'react'
import ReactDOM from 'react-dom/client'
import './styles/index.css'

// The public builder catalog (/materialy) is opened on phones from Telegram.
// Load it on its own instead of behind the whole dashboard bundle.
const isBuilderCatalog = window.location.pathname.replace(/\/+$/, '') === '/materialy'
// The builder's warranty jobs (/w/:token…) — same audience, same treatment:
// opened from Telegram/SMS, no login, no dashboard bundle.
const isBuilderWarranty = window.location.pathname.startsWith('/w/')
// The planner's personal link (/p/:token) — opened from their e-mails, no login.
const isPlannerPortal = window.location.pathname.startsWith('/p/')
// The flat's builder fixes the pre-handover inspection findings (/h/:token) — from Telegram, no login.
const isBuilderHandover = window.location.pathname.startsWith('/h/')

// Local development only: /dev-login turns a one-time token from
// scripts/dev-login.mjs into a session (no Google sign-in for local screenshots).
// import.meta.env.DEV is false in the production build, so Vite drops this
// branch and the page entirely — it cannot exist on internal.scandi.ee.
const isDevLogin = import.meta.env.DEV
  && window.location.pathname === '/dev-login'
  && ['localhost', '127.0.0.1'].includes(window.location.hostname)

const loadRoot = isDevLogin
  ? import('./pages/DevLogin.jsx').then((m) => m.DevLogin)
  : isBuilderCatalog
  ? import('./pages/MaterialsCatalog.jsx').then((m) => m.MaterialsCatalog)
  : isBuilderWarranty
    ? import('./pages/WarrantyBuilder.jsx').then((m) => m.WarrantyBuilder)
  : isPlannerPortal
    ? import('./pages/PlannerPortal.jsx').then((m) => m.PlannerPortal)
  : isBuilderHandover
    ? import('./pages/HandoverBuilder.jsx').then((m) => m.HandoverBuilder)
    // Dashboard: the shell and the active language's text download together
    // (only that one language — src/i18n/index.js); render once both are in.
    : Promise.all([
      import('./i18n').then((m) => m.i18nReady).catch((err) => console.error('[i18n] language not loaded', err)),
      import('./App.jsx'),
    ]).then(([, m]) => m.default)

loadRoot.then((Root) => {
  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <Root />
    </React.StrictMode>,
  )
})
